import React from 'react'
import SolutionHeroPage from '../../components/SolutionsComponent/SolutionHeroPage'
import Header from '../../components/shared/Header'
import CarbonTracking from '../../components/SolutionsComponent/CarbonTracking'
import SolutionsSection from '../../components/SolutionsComponent/SolutionSection'
import Footer from '../../components/shared/Footer'
function SolutionPage() {
  return (
    <div className='bg-[#FAFAFA] '>

    
    <Header/>

<SolutionHeroPage/>
<SolutionsSection/>
    <CarbonTracking/>
  <Footer/>
    
    </div>

)
}

export default SolutionPage